class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.header = this.closest("header");
    this.targets = document.querySelectorAll("[data-header-target]");
    this.sticking = false;
    this.accordions = this.querySelectorAll("[data-accordion-item]");
    this.pencilBar = document.querySelector("[data-pencil-bar]");
    this.pencilBarHeight = 0;
    this.modifiedByScrolling = this.pencilBar ? false : true;
    this.scrollDirection = null;
    this.scrollPosition = 0;

    if (this.pencilBar) {
      this.header.style.paddingTop = 0;
      this.pencilBarHeight = this.pencilBar.getBoundingClientRect().height;
      this.header.style.top = this.pencilBarHeight + "px";
    }

    // Determine total height and set CSS variable
    this.totalHeight =
      document.querySelector("header").getBoundingClientRect().height +
      this.pencilBarHeight;

    const setHeightVariable = () =>
      document.documentElement.style.setProperty(
        "--header-height",
        `${this.totalHeight}px`,
      );

    this._moveStickTarget();
    this._initObserver();

    window.requestAnimationFrame(setHeightVariable);
    window.addEventListener("resize", setHeightVariable);
    window.addEventListener("scroll", () => this._updateScrollDirection());

    setInterval(() => {
      if (this.modifiedByScrolling) {
        if (this.scrollDirection == "up") {
          this.header.style.top = this.pencilBar ? "30px" : "0";
        } else if (this.scrollDirection == "down") {
          this.header.style.top = "-100%";
        }
      }
    }, 300);
  }

  connectedCallback() {
    document.addEventListener("pencilbar:hide", () => {
      this._handlePencilBarHide();
    });

    document.addEventListener("mini-cart:open", () => {
      if (this.modifiedByScrolling) {
        this.scrollDirection = "up";
        this.header.style.top = this.pencilBar ? "30px" : "0";
      }
    });

    this.accordions.forEach((accordion) => {
      accordion.addEventListener("mouseover", () => {
        this.toggleAccordions(accordion);
        accordion.classList.add("active");

        accordion.dispatchEvent(
          new CustomEvent("global-accordion:hover-opened", { bubbles: true }),
        );
      });

      accordion.addEventListener("focusout", (e) => {
        if (!this.contains(e.relatedTarget)) {
          this.toggleAccordions(null);
        }
      });

      document.addEventListener("click", (e) => {
        if (!this.contains(e.target)) {
          this.toggleAccordions(null);
        }
      });
    });
  }

  _handlePencilBarHide() {
    this.header.style.top = "30px";
    this.pencilBarHeight = 30; // Make sure we have padding when pencil bar is hidden
  }

  _updateScrollDirection() {
    if (!this.header.classList.contains("header--enable-scrolling")) {
      this.header.classList.add("header--enable-scrolling");
    }

    if (!document.body.classList.contains("mini-cart-open")) {
      this.scrollDirection =
        document.body.getBoundingClientRect().top > this.scrollPosition
          ? "up"
          : "down";
      this.scrollPosition = document.body.getBoundingClientRect().top;
    }
  }

  _initObserver() {
    const cb = (entries) => {
      entries.forEach((entry) => {
        switch (entry.target.dataset.headerTarget) {
          case "stick":
            this.sticking = !entry.isIntersecting;
            this.modifiedByScrolling = this.sticking;

            setTimeout(() => {
              this.classList.toggle("sticking", this.sticking);
              document.body.classList.toggle("header--grey", this.sticking);
              document.body.classList.toggle("header--sticking", this.sticking);
            }, 300);

            this.sticking
              ? (this.header.style.top = "-100%")
              : (this.header.style.top = this.pencilBarHeight + "px");

            break;
        }
      });
    };

    const observer = new IntersectionObserver(cb, {});
    this.targets.forEach((target) => {
      observer.observe(target);
    });
  }

  _moveStickTarget() {
    // Moving this element in editor messes things up (sections disappear when you change things)
    // so just skip.
    if (Shopify?.designMode) return;

    // Move stick target before header (but after promo bar, if present)
    // We can't directly place the target there because these are both
    // sections in a section group.
    const target = document.querySelector('[data-header-target="stick"]');
    const header = this.closest(".shopify-section--header");
    header.parentNode.insertBefore(target, header);
  }

  toggleAccordions(currentItem) {
    this.accordions.forEach((accordion) => {
      if (accordion !== currentItem) {
        accordion.classList.remove("active");
      }
    });
  }
}

if (!customElements.get("sticky-header")) {
  customElements.define("sticky-header", StickyHeader);
}
